import { ThemeUICSSObject, spacing } from '@apia/theme';

const infoBox: ThemeUICSSObject = {
  p: spacing(4),
  display: 'flex',
  alignItems: 'center',
  gap: spacing(4),
  border: '1px solid',
  justifyContent: 'space-between',
  borderColor: 'palette.border.field',

  '& > div': {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(4),

    '&:last-of-type': {
      textAlign: 'right',
    },
  },
};

export default infoBox;
